import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
//import propertytypesApi from "../../api/propertytype";
import IntlMessages from '../../components/IntlMessage';
import {
  Button,
  Card,
  Table,
  Modal,
  Row,
  Col,
  Space,
  Image,
  Typography,
  Switch,
} from 'antd';
import PageTitle from '../../components/PageTitle';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import OperatorsForm from './OperatorsForm';
import operatorsApi from '../../api/operators';
import FilterBar from '../../components/FilterBar';
import zalo_icon from '../../assets/img/zalo_icon.png';
import UserOperatorsForm from './UserOperatorForm';

const { Text } = Typography;

Operators.propTypes = {
  items: PropTypes.array,
};
Operators.defaultProps = {
  items: [],
};

function Operators(props) {
  // const isMount = useRef(false)

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [modal, setModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalUserOperator, setModalUserOperator] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await operatorsApi.getAll(filter);

      setItems(items.data);
      setLoading(false);
      // setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const onOpenModalUserOperator = (record = null) => {
    setModalUserOperator(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModalUserOperator = () => {
    setModalUserOperator(false);
  };
  const intl = useIntl();
  // const onRemove = (data) => {
  //   Modal.confirm({
  //     title: intl.formatMessage({ id: 'global.delete_confirm' }),
  //     okText: intl.formatMessage({ id: 'global.yes' }),
  //     onOk: async () => {
  //       await operatorsApi.delete(data.id).catch((error) => {
  //         console.error(error);
  //         Modal.error({
  //           title: error.data.message,
  //           okText: intl.formatMessage({ id: 'global.close' }),
  //         });
  //         setLoading(false);
  //       });
  //       setDeleting(true);
  //     },
  //     onCancel() {},
  //   });
  // };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await operatorsApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const onChangeStatus = async (ischecked, record) => {
    // console.log(ischecked);
    await operatorsApi.update(record.id, { status: ischecked });

    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            status: ischecked,
          };
        return data;
      })
    );
  };
  const columns = [
    // {
    //   title: <IntlMessages id="global.no" />,
    //   width: 20,
    //   render: (_, record, index) => {
    //     return index + 1 + filter.limit * (filter.page - 1);
    //   },
    // },
    {
      title: <IntlMessages id="global.logo" />,
      key: 'image',
      dataIndex: 'image',
      render: (_, record) => {
        return record.image ? <Image width={50} src={record.image} /> : '';
      },
    },
    {
      title: <IntlMessages id="global.title" />,
      key: 'title',
      sorter: true,
      dataIndex: 'title',
      render: (_, record) => {
        return (
          <Button
            type="link"
            size="small"
            onClick={() => onOpenModal(record)}
            shape="round">
            {record.title}
          </Button>
        );
      },
    },
    {
      title: <IntlMessages id="global.firstname" />,
      key: 'firstname',
      sorter: true,
      dataIndex: 'firstname',
      render: (_, record) => {
        return `${record.firstname}`;
      },
    },
    {
      title: <IntlMessages id="global.lastname" />,
      key: 'lastname',
      sorter: true,
      dataIndex: 'lastname',
      render: (_, record) => {
        return `${record.lastname}`;
      },
    },
    {
      title: <IntlMessages id="global.email" />,
      key: 'email',
      sorter: true,
      dataIndex: 'email',
      render: (_, record) => {
        return `${record.email}`;
      },
    },
    {
      title: <IntlMessages id="global.short_name" />,
      key: 'short_name',
      sorter: true,
      dataIndex: 'short_name',
      render: (_, record) => {
        return `${record.short_name}`;
      },
    },
    {
      title: <IntlMessages id="global.phone" />,
      key: 'phone',
      sorter: true,
      dataIndex: 'phone',
      render: (_, record) => {
        return (
          record?.phone && (
            <Space size={4}>
              <Text>{record.phone}</Text>
              {/* <a href={`https://zalo.me/${record.phone}`} target="_blank">
                <Image
                  style={{
                    width: '20px',
                  }}
                  preview={false}
                  src={zalo_icon}
                />
              </a> */}
            </Space>
          )
        );
      },
    },
    {
      title: <IntlMessages id="global.status" />,
      key: 'status',
      dataIndex: 'status',
      width: 100,
      render: (e, record) => (
        <Space direction="vertical" size={2}>
          <Switch
            checkedChildren={''}
            unCheckedChildren={''}
            checked={!!e}
            onChange={(isChecked) => onChangeStatus(isChecked, record)}
          />
        </Space>
      ),
    },
    {
      title: <IntlMessages id="global.user_id" />,
      key: 'userId',
      dataIndex: 'userId',
      render: (text, record, index) => {
        return record?.user?.id ? record.user?.id : 'N/A';
      },
    },
    {
      key: 'btn',
      title: '',
      render: (text, record) => {
        return (
          <Button
            shape="round"
            size="small"
            type="primary"
            onClick={() => onOpenModalUserOperator(record)}>
            <IntlMessages id="global.agency_staff" />
          </Button>
        );
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          {' '}
          <PageTitle title={<IntlMessages id="global.operators" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            deleteMessage={
              'Warning! You are about to delete this operator and its associated records. Are you sure you want to delete this record?'
            }
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={true}
            isDisabled={!(selectedRowKeys.length > 0)}></ActionBar>
        </Col>
      </Row>

      <FilterBar
        onFilter={onFilter}
        data={[
          {
            name: 'status',
            data: [
              { id: '1', title: <IntlMessages id="global.active" /> },
              { id: '0', title: <IntlMessages id="global.deactivate" /> },
            ],
            placeholder: <IntlMessages id="global.status" />,
          },
        ]}></FilterBar>

      <br />

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        rowSelection={rowSelection}
      />
      {modal ? (
        <OperatorsForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {modalUserOperator ? (
        <UserOperatorsForm
          open={modalUserOperator}
          onClose={onCloseModalUserOperator}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
    </Card>
  );
}

export default Operators;
